var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { BehaviorSubject } from 'rxjs';
import { JwtHelperService } from '@auth0/angular-jwt';
import { AuthTokenService } from './auth-token.service';
import { CommonRequestService } from './common-request.service';
import { AppSettings } from './../app.settings';
var UserService = /** @class */ (function () {
    function UserService(jwtHelper, tokenService, requestService) {
        this.jwtHelper = jwtHelper;
        this.tokenService = tokenService;
        this.requestService = requestService;
        // public selectedCustomerId: BehaviorSubject<number> = new BehaviorSubject(null);
        this.selectedCustomer = new BehaviorSubject(null);
        // The item name to store selectedCustomer in localStorage
        this.selectedCustomerItemName = 'selectedCustomer';
        this.hasUserSubscription = false;
        this._a3iApiKeyName = 'a3iApiKey';
        this.token = localStorage.getItem(this.tokenService.authTokenName);
    }
    UserService.prototype.appInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                // set token from local storage
                this.token = localStorage.getItem(this.tokenService.authTokenName);
                return [2 /*return*/];
            });
        });
    };
    UserService.prototype.getUserInfo = function () {
        return this.userInfo;
    };
    UserService.prototype.getCurrentToken = function () {
        return this.token;
    };
    UserService.prototype.setUserInfoFromToken = function () {
        var info;
        if (!this.userInfo) {
            this.userInfo = {
                customerId: null,
                customerEmail: null,
                customerName: null,
                userId: null,
                userName: null,
                userEmail: null,
                isAdmin: null
            };
        }
        // this.userInfo = {};
        if (!this.token || this.token === 'undefined' || this.jwtHelper.isTokenExpired(this.token)) {
            this.removeToken();
            console.log('No Token Exists!');
            this.userInfo = {
                customerId: null,
                customerEmail: null,
                customerName: null,
                userId: null,
                userName: null,
                userEmail: null,
                isAdmin: null
            };
            return;
        }
        info = this.jwtHelper.decodeToken(this.token);
        this.userInfo.customerId = info.cus_id; // Agency Id
        this.userInfo.customerName = info.cus_name_short; // Agency Name
        this.userInfo.customerEmail = info.cus_email; // Agency Admin's Email
        this.userInfo.userEmail = info.usr_email;
        this.userInfo.userId = info.usr_id;
        this.userInfo.isAdmin = info.usr_admin_flag;
        this.userInfo.parentCustomerId = info.cus_parent_id;
        this.userInfo.isSuperAdmin = info.usr_sa_flag;
    };
    UserService.prototype.updateUserInfoFromUserSub = function (userSub) {
        this.userInfo.subscriptionId = userSub.subId;
        this.userInfo.userSubId = userSub.userSubId;
        this.userSubscription = userSub;
    };
    UserService.prototype.setUpdatedToken = function (token) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!token) {
                            console.log('token updated failed. token: ' + token);
                            return [2 /*return*/];
                        }
                        this.token = token;
                        localStorage.setItem(this.tokenService.authTokenName, token);
                        this.setUserInfoFromToken();
                        // Update customerInfo
                        return [4 /*yield*/, this.getCustomerInfo(this.userInfo.customerId, true, true)];
                    case 1:
                        // Update customerInfo
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    UserService.prototype.removeToken = function () {
        // clear token remove user from local storage to log user out
        this.token = null;
        localStorage.removeItem(this.tokenService.authTokenName);
        localStorage.removeItem('userInfo');
    };
    UserService.prototype.getHasUserSubscription = function () {
        return this.hasUserSubscription;
    };
    UserService.prototype.setHasUserSubscription = function (hasUserSub) {
        this.hasUserSubscription = hasUserSub;
    };
    UserService.prototype.isTokenExpired = function () {
        return this.jwtHelper.isTokenExpired(this.tokenService.getToken());
    };
    UserService.prototype.isLoggedIn = function () {
        return !this.isTokenExpired() && this.hasUserSubscription;
    };
    // @updateOrigin: to update the customerInfo object with the service result or keep it as before 
    UserService.prototype.getCustomerInfo = function (cusId, updateOrigin, getParentInfo) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            cusId = cusId || _this.userInfo.customerId;
            if (!cusId && cusId !== 0) {
                console.log('Failed to get CustomerInfo; cusId did not exist');
                reject();
            }
            var url = AppSettings.serviceRootUrl + 'admin/customer';
            _this.requestService.requestGet(url, {
                params: {
                    customerId: cusId
                }
            }, function (rsp) { return __awaiter(_this, void 0, void 0, function () {
                var data, info, selectedCustomer_1, parentInfo;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            data = rsp.data[0];
                            info = {
                                id: data.cus_id,
                                nameLong: data.cus_name_long,
                                nameShort: data.cus_name_short,
                                type: data.cus_type,
                                adminEmails: data.admin_emails,
                                level: data.level,
                                parentId: data.cus_parent_id,
                                children: data.cus_child ? data.cus_child.map(function (c) { return ({
                                    id: c.id,
                                    name: c.name,
                                    adminEmails: c.admin_emails
                                }); }) : [],
                                givState: data.cus_state,
                                cusCounties: data.cus_counties || [],
                                cusCentroid: data.cus_centroid,
                                neighborCounties: data.ngm_neighbors || [],
                                discrepancyId: data.cus_discrp_ag_id,
                                bdryCate: data.cus_giv_boundary_cat,
                                bdryName: data.cus_giv_boundary_name,
                                nguidPattern: {
                                    layerType: data.cus_nguid_pattern === 2 ? true : false
                                }
                            };
                            info.children.sort(function (a, b) {
                                if (a.name < b.name) {
                                    return -1;
                                }
                                else if (a.name > b.name) {
                                    return 1;
                                }
                                else {
                                    return 0;
                                }
                            });
                            if (updateOrigin) {
                                this.customerInfo = info;
                                selectedCustomer_1 = this.selectedCustomer.getValue();
                                if (selectedCustomer_1 && selectedCustomer_1.id) {
                                    switch (info.type) {
                                        case 'integrator':
                                            if (!this.clients || !this.clients.find(function (c) { return c.cusId === selectedCustomer_1.id; })) {
                                                // this.selectedCustomerId.next(null);
                                                this.selectedCustomer.next(null);
                                            }
                                            break;
                                        default:
                                            if (selectedCustomer_1.id !== this.customerInfo.id && !this.customerInfo.children.find(function (c) { return c.id === selectedCustomer_1.id; })) {
                                                // this.selectedCustomerId.next(null);
                                                this.selectedCustomer.next(null);
                                            }
                                    }
                                }
                            }
                            if (!(getParentInfo && info.parentId)) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.getCustomerInfo(info.parentId, false)];
                        case 1:
                            parentInfo = _a.sent();
                            info.parentEmails = parentInfo.adminEmails;
                            info.parentName = parentInfo.nameShort;
                            _a.label = 2;
                        case 2:
                            resolve(info);
                            return [2 /*return*/];
                    }
                });
            }); }, function (err) { return reject(err); });
        });
    };
    // TODO: merge getCustomerIdByTpe & getSelectedCustomerInfo ///////
    // Get customer id by customer type
    // For end-user, customerId is their agency's id; For integrator, it's their client agency's id
    UserService.prototype.getCustomerIdByType = function () {
        switch (this.customerInfo.type) {
            case 'integrator':
                var selectedCustomer = this.selectedCustomer.getValue();
                return selectedCustomer ? selectedCustomer.id : null;
            default:
                return this.getUserInfo().customerId;
        }
    };
    UserService.prototype.getSelectedCustomerInfo = function (info) {
        switch (this.customerInfo.type) {
            case 'integrator':
                var selectedCustomer_2 = this.selectedCustomer.getValue();
                if (info === 'stateCode') {
                    var client = this.clients.find(function (c) { return c.cusId === selectedCustomer_2.id; });
                    if (client) {
                        return client.givState;
                    }
                    else {
                        console.log('Can not find client!');
                    }
                }
                else { // Return id as default
                    return selectedCustomer_2 ? selectedCustomer_2.id : null;
                }
                return selectedCustomer_2 ? selectedCustomer_2.id : null;
            default:
                if (info === 'stateCode') {
                    return this.customerInfo.givState;
                }
                else {
                    return this.getUserInfo().customerId;
                }
        }
    };
    // Currently using give usbId instead of a3i usbId
    UserService.prototype.generateApiKey = function (pw, a3iUsbId) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var url = AppSettings.serviceRootUrl + 'admin/apiKey';
            var body = {
                email: _this.userInfo.userEmail,
                password: pw,
                permissions: JSON.stringify({
                    A3I: {
                        userSubscriptionId: a3iUsbId
                    }
                })
            };
            return _this.requestService.requestPost(url, body, function (rsp) {
                _this._a3iApiKey = rsp.data.content;
                localStorage.setItem(_this._a3iApiKeyName, _this._a3iApiKey);
                resolve(_this._a3iApiKey);
            }, function (err) { return reject(err); }, true);
        });
    };
    UserService.prototype.getA3iApiKey = function () {
        return this._a3iApiKey || localStorage.getItem(this._a3iApiKeyName);
        // if (environment.envName === 'dev') {
        // 	return this._a3iApiKey;
        // } else {
        // 	return this._a3iApiKey_test;
        // }
    };
    UserService.prototype.removeA3iApiKey = function () {
        this._a3iApiKey = null;
        localStorage.removeItem(this._a3iApiKeyName);
    };
    UserService.prototype.getStatesFromNeighborCounties = function () {
        var states = this.customerInfo.neighborCounties.map(function (i) { return i.split(' - ')[0]; });
        var distinctStates = states.filter(function (i, idx) { return idx === states.indexOf(i); });
        return distinctStates;
    };
    UserService.prototype.getNeighborCountiesFromCustomer = function () {
        var counties = this.customerInfo.neighborCounties.map(function (i) {
            var splits = i.split(' - ');
            if (splits.length > 1) {
                return {
                    label: i,
                    value: splits[1]
                };
            }
        });
        return counties;
    };
    return UserService;
}());
export { UserService };
